// ref: https://github.com/outline/outline/blob/5ae48343330f9802806f418d707882d729803b7d/shared/editor/marks/Code.ts
import { Slice } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

import { EditorOptions, EditorView } from '@lyearn/lygo-core';

import { isInCode } from '../../../utils';

function plugins(_editorOptions: EditorOptions): Plugin[] {
  return [
    new Plugin({
      props: {
        handleTextInput: (view: EditorView, from: number, to: number, text: string) => {
          const { state } = view;
          if (!isInCode(state)) {
            return false;
          }

          // Prevent access out of document bounds
          if (from === 0 || to === state.doc.nodeSize - 1 || text === '`') {
            return false;
          }

          if (
            from === to &&
            state.doc.textBetween(from - 1, from) === '`' &&
            state.doc.textBetween(to, to + 1) === '`'
          ) {
            const start = from - 1;
            const end = to + 1;
            view.dispatch(
              state.tr
                .delete(start, end)
                .insertText(text, start)
                .addMark(start, start + text.length, state.schema.marks.code_inline.create()),
            );
            return true;
          }

          return false;
        },

        handlePaste: (view: EditorView, _event: Event, slice: Slice) => {
          const { state } = view;
          const { from, to } = state.selection;

          if (!isInCode(state)) {
            return false;
          }

          // Prevent access out of document bounds
          if (from === 0 || to === state.doc.nodeSize - 1) {
            return false;
          }

          const start = from - 1;
          const end = to + 1;
          if (
            from === to &&
            state.doc.textBetween(start, from) === '`' &&
            state.doc.textBetween(to, end) === '`'
          ) {
            view.dispatch(
              state.tr
                .replaceRange(start, end, slice)
                .addMark(start, start + slice.size, state.schema.marks.code_inline.create()),
            );
            return true;
          }

          return false;
        },
      },
    }),
  ];
}

export default plugins;
